import React from 'react'
import PurchasingGroupStage2 from "./stage2/PurchasingGroupStage2";
import PurchasingGroupStage1 from "./stage1/PurchasingGroupStage1";


function PurchasingGroupStageNr(
    {
        match
    }) {
    const stage = match.params.stage;
    return (stage === "2" ? <PurchasingGroupStage2/> : <PurchasingGroupStage1/>)
}

PurchasingGroupStageNr.propTypes = {}

export default PurchasingGroupStageNr;
	
